import gql from 'graphql-tag'  //引入graphql
const apollo={
	qa:gql`query qa($start:Int!,$limit:Int,$userId:String,$startDate:Date,$endDate:Date){
		qaRecords(start:$start,limit:$limit,userId:$userId,startDate:$startDate,endDate:$endDate){
		    totalCount
		    edges{
		      node{
		        id
		        question
		        answer
		        userName
		        createTime
		      }
		    }
		}
	}`,
	findList:gql`query findList($id:String,$start:Int!,$limit:Int,$status:Int,$recommStatus:Int,$keyword:String,$isRandom:Boolean,$similar:Boolean){
	    standardQuestions(id:$id,start:$start,limit:$limit,status:$status,recommStatus:$recommStatus,keyword:$keyword,isRandom:$isRandom,similar:$similar){
            totalCount
            edges{
                node{
                    id
                    question
                    similarCount
                    recommCount
                    similarQuestions{
                        edges{
                            node{
                                id
                            }
                        }
                    }
                }
            }
	    }
	}`,
	list:gql`query list($start:Int, $limit:Int,$keyword:String,$id: String, $tenantId: String,$status: String){
		robotInfos(start:$start,limit:$limit,keyword:$keyword,id:$id,tenantId:$tenantId,status:$status){
		  totalCount
		  edges{
			node{
			  id   
			  image
			  name
			  updateTime
			  createTime
			  }
			}
		  }
	  }`
}
export default apollo


// WEBPACK FOOTER //
// ./src/aiDialog/graphql/apollo.js